export default __webpack_public_path__ + "static/og-8995373223cdf3f1c2f9ede27acad9b8.png";